import { eraseCookie } from "../config/CookieScript"

// message shown on the login page after a forced logout (e.g. account deactivated)
export const LOGOUT_MESSAGE_KEY = 'logout_message'

// clear the login and go to the login page
// plain function (no React hooks) so it can be called from axios interceptors
export const logOut = (message) => {
    eraseCookie('auth_token')
    localStorage.clear()
    if (message) {
        try {
            sessionStorage.setItem(LOGOUT_MESSAGE_KEY, message)
        } catch (e) {
            // storage unavailable: the login page just won't show the reason
        }
    }
    window.location.assign('/')
}

// read and clear the message left by a forced logout
export const takeLogOutMessage = () => {
    try {
        const message = sessionStorage.getItem(LOGOUT_MESSAGE_KEY)
        sessionStorage.removeItem(LOGOUT_MESSAGE_KEY)
        return message
    } catch (e) {
        return null
    }
}
